// Plan request function (the centralized service layer; FRONTEND_RULES §9).
// Pure async over the shared client — no Redux, no React. Plan-level data is
// shared by every participant enrolled in the plan (branding, fund lineup, IRS
// limits); the header reads its logo branding from here via the planBranding slice.

import { apiGet } from './client';

/**
 * GET /plans/{planId} — the shared plan definition (branding, fund lineup,
 * IRS limits, match formula, election/transfer rules) for one plan.
 * @param {string} planId e.g. "PLAN-ACME-401K"
 */
export function getPlan(planId) {
  return apiGet(`/plans/${encodeURIComponent(planId)}`);
}
